<template>
  <es-popup
    show="{{show}}"
    position="{{position}}"
    class="custom-class"
    bind:close="close"
    wx:if="{{show}}"
  >
    <view class="drawer-container">
      <slot name="header"></slot>
      <view class="drawer-main custom-main">
        <slot />
      </view>
    </view>
  </es-popup>
</template>

<script>
import { createComponent } from "@didi/es-mpx-creator";
createComponent({
  classes: ['custom-main'],

  props: {
    show: {
      type: Boolean,
      value: false,
    },
  },
  data() {
    return {
      position: "bottom",
    };
  },
  methods: {
    close() {
      this.$trigger("close");
    },
  },
});
</script>

<style lang="stylus" scoped>
.drawer-container 
  width 100vw
  max-height 80vh
  background #ffffff
  border-radius 16px 16px 0 0
  overflow hidden

.drawer-main 
  padding 0 12px
  overflow auto
  max-height calc(80vh - 60px)

</style>

<script name="json">
module.exports = {
  component: true,
  usingComponents: {
    "es-navbar": "@didi/es-mpx-ui/lib/navbar",
    "es-popup": "@didi/es-mpx-ui/lib/popup",
    "es-icon": "@didi/es-mpx-ui/lib/icon",
  },
};
</script>
